import { schema } from 'normalizr';

export const phoneNumberSchema = new schema.Entity('phoneNumber');
